import React from 'react'
import queryString from 'query-string'
import { useHistory } from 'react-router-dom'

import { ZariContext } from '_zari/context'
import { Table, Button } from '_zari/core'

import { CodigosTransaccionesConstant, SeInventarios, TiposOperacionSunat } from 'constants/index'

import * as InventariosService from 'services/inventario.service'

const RowTemplate = ({ mainRow, clickAgregarSalida, clickEditar, centroSeleccionadoNivel1, centroSeleccionadoNivel2 }) => {
  const __zariContext = React.useContext(ZariContext)
  const [mostrarTablaSalidas, setMostrarTablaSalidas] = React.useState(false)

  const history = useHistory()

  const tablaSalidasRef = React.useRef(null)

  const clickVerSalidas = React.useCallback(() => {
    setMostrarTablaSalidas(prev => !prev)
  }, [])

  const clickEditarSalida = React.useCallback(
    ({ _id }) => {
      let objetoUrl = {
        t: SeInventarios.SALIDA,
        to: TiposOperacionSunat.SALIDA_POR_SERVICIO_DE_PRODUCCIÓN,
        taller: _id,
        cc1: centroSeleccionadoNivel1,
        cc2: centroSeleccionadoNivel2
      }

      const queryParams = queryString.stringify(objetoUrl)

      history.push(`/${CodigosTransaccionesConstant.INVENTARIOS_ENTRADASALIDA_NUEVO}/${_id}?${queryParams}`)
    },
    [history, centroSeleccionadoNivel1, centroSeleccionadoNivel2]
  )

  const clickEliminarSalida = React.useCallback(
    async ({ _id }) => {
      await InventariosService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado.')
          tablaSalidasRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <Table.Row hover>
        <Table.Cell>
          <Button tiny outline onClick={clickVerSalidas}>
            V
          </Button>
        </Table.Cell>
        <Table.Cell>{mainRow.fechaIngreso || '--'}</Table.Cell>
        <Table.Cell>{mainRow.titulo || '--'}</Table.Cell>
        <Table.Cell>{mainRow.monto || '--'}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='agregar' handleClose={handleClose} onClick={e => clickAgregarSalida({ _id: mainRow._id })}>
                Agregar Salida
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: mainRow._id })}>
                Editar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
      {mostrarTablaSalidas && (
        <Table.Row hover>
          <Table.Cell colSpan={5}>
            <Table.ServerSide
              useNest={true}
              ref={tablaSalidasRef}
              baseParams={{
                tipoConsulta: 'talleres',
                idTaller: mainRow._id
              }}
              url='/kardex'
              headRows={[{ label: 'TITULO' }, { label: 'FECHA' }, { label: 'DOCUMENTO' }, { label: '' }]}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.titulo || '--'}</Table.Cell>
                  <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell>{`${row.tipoDocumento} - ${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditarSalida({ _id: row._id })}>
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminarSalida({ _id: row._id })}>
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Table.Cell>
        </Table.Row>
      )}
    </>
  )
}

export default React.memo(RowTemplate)
